import { isDateValid, parseDate } from "@lyfegen-platform/utils";
import { EMPTY_VALUE_PLACEHOLDER } from "../models/common/data";

interface Props {
	monthFormat?: boolean;
	isPeriodString?: string;
	placeholder?: string;
	timeFormat?: boolean;
}

export const localeDate = (date: Date | string | number | undefined | null, props?: Props) => {
	const datePlaceholder = props?.placeholder || EMPTY_VALUE_PLACEHOLDER;
	if (!date) {
		return datePlaceholder;
	}

	let newDate = date;
	if (typeof newDate === "string") {
		newDate = parseDate(newDate.trim()) as Date;
		if (!isDateValid(newDate)) {
			return datePlaceholder;
		}
	}

	if (typeof newDate === "number") {
		newDate = parseDate(newDate) as Date;
	}

	if (!newDate.getFullYear()) {
		return props?.placeholder || EMPTY_VALUE_PLACEHOLDER;
	}

	const locale = window.navigator.languages[0] || "fr-CA";
	if (props?.monthFormat) {
		return `${newDate.toLocaleDateString(locale, { month: "short" })}-${String(newDate.getFullYear()).slice(-2)}`;
	}

	if (props?.timeFormat) {
		return newDate.toLocaleString(locale);
	}

	return Array.isArray(newDate)
		? `${newDate[0].toLocaleDateString(locale)}-${newDate[1].toLocaleDateString(locale)}`
		: newDate.toLocaleDateString(locale);
};
